import { GoogleOAuthProvider } from '@react-oauth/google';

export const SocialProviders = ({ children }: React.PropsWithChildren) => {
  return (
    <GoogleOAuthProvider clientId="698605344031-f5usl4c4br4lmjr6m7u2p3fg92b2hfpc.apps.googleusercontent.com">
      {children}
    </GoogleOAuthProvider>
  );
};
